import React, { FC } from 'react';

interface loadingProps {
  showInfo?: boolean;
  sizeClass?: string;
}

export const EmployeeThumbLoading: FC<loadingProps> = ({
  showInfo = false,
  sizeClass = 'w-8 h-8',
}) => {
  return (
    <div className="flex items-center gap-3">
      {/* Avatar skeleton */}
      <div
        className={`rounded-full ring-2 ring-gray-200 dark:ring-gray-700 
        ${sizeClass} bg-gray-200 dark:bg-slate-800 
        animate-pulse`}
      />

      {showInfo && (
        <div className="flex flex-col gap-1">
          {/* Title */}
          <div className="h-4 w-24 bg-gray-200 dark:bg-slate-800 rounded animate-pulse" />

          {/* Subtitle */}
          <div className="h-3 w-32 bg-gray-200 dark:bg-slate-800 rounded animate-pulse" />
        </div>
      )}
    </div>
  );
};

export default EmployeeThumbLoading;
